import { createFileRoute, redirect } from "@tanstack/react-router";
import { writeDisplayMode } from "@/lib/timer/timer-view-store";

/** Angular `/calendar-timer` -> React timer calendar mode. */
export const Route = createFileRoute("/_app/calendar-timer/")({
	beforeLoad: () => {
		if (typeof window !== "undefined") {
			writeDisplayMode("calendar");
		}
		throw redirect({ to: "/timer" });
	},
});
